// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Subscriptions_AdminSweepRunRow.php
// Do not edit by hand — edit the PHP RowContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Subscriptions_AdminSweepRunRow — one recorded INVOCATION of the sweep
 * mechanism (subscription_sweep_runs), for GET /subscriptions/admin/sweep/runs.
 *
 * This is the round's diary, not the cut's audit trail: a cut also appears in
 * subscription_events, but a deferred, a refused, a gateway failure, a not_due
 * or a breaker refusal appears NOWHERE else.
 *
 * Fields:
 *   id                     — subscription_sweep_runs.id
 *   trigger_source         — 'cli' | 'staff_page' | 'staff_subscription'
 *   triggered_by           — Cognito sub of the staff caller, or 'internal-token'
 *                            for the CLI door (no user, only a shared secret)
 *   target_subscription_id — set only for the single-row door; NULL for a round
 *   started_at/finished_at — ISO-8601 UTC (stored GMT-3, converted on the wire)
 *   candidate_count        — how many rows the predicate found due
 *   cancelled/deferred/refused/failed_count — the same four buckets the round
 *                            reports, derived from `outcomes`
 *   circuit_open           — the breaker refused the round; nothing was cut
 *   cutoff                 — end-of-day boundary the round cut against, ISO-8601 UTC
 *   outcomes               — per-candidate trail
 *                            [{subscription_id, outcome, reason|null}], decoded
 */
import type { Subscriptions_AdminSweepRunOutcomeRow } from './Subscriptions_AdminSweepRunOutcomeRow'
import { registerContract } from './validate'

export interface Subscriptions_AdminSweepRunRow {
id: number
trigger_source?: string
triggered_by?: string
target_subscription_id?: number
started_at?: string
finished_at?: string
candidate_count?: number
cancelled_count?: number
deferred_count?: number
refused_count?: number
failed_count?: number
circuit_open?: boolean
cutoff?: string
outcomes?: Subscriptions_AdminSweepRunOutcomeRow[]
}

registerContract('Subscriptions_AdminSweepRunRow', {
  id:                     { type: 'number',  required: true },
  trigger_source:         { type: 'string',  required: false },
  triggered_by:           { type: 'string',  required: false },
  target_subscription_id: { type: 'number',  required: false },
  started_at:             { type: 'string',  required: false },
  finished_at:            { type: 'string',  required: false },
  candidate_count:        { type: 'number',  required: false },
  cancelled_count:        { type: 'number',  required: false },
  deferred_count:         { type: 'number',  required: false },
  refused_count:          { type: 'number',  required: false },
  failed_count:           { type: 'number',  required: false },
  circuit_open:           { type: 'boolean', required: false },
  cutoff:                 { type: 'string',  required: false },
  outcomes: {
    type: 'array',
    required: false,
    items: {
      subscription_id: { type: 'number',  required: false },
      outcome:         { type: 'string',  required: false },
      reason:          { type: 'string',  required: false },
    },
  },
})
